import { ListResponse, Result } from '@shared/models';

export type ListStoreState<T> = {
  response: ListResponse<T>;
  loading: boolean;
  loaded: boolean;
  errorMessage: string | null;
};

export type CommandState<T = unknown> = {
  commandInProgress: boolean;
  lastCommandName: string | null;
  lastCommandResult: Result<T> | null;
};

export type CommandResult<T = unknown> = Result<T> & {
  commandName: string;
};

export function emptyListResponse<T>(): ListResponse<T> {
  return { records: [] } as ListResponse<T>;
}

export function initialListStoreState<T>(): ListStoreState<T> {
  return {
    response: emptyListResponse<T>(),
    loading: false,
    loaded: false,
    errorMessage: null,
  };
}

export function resultErrorMessage<T>(result: Result<T>, fallback: string): string {
  return result.message || fallback;
}

export function initialCommandState<T = unknown>(): CommandState<T> {
  return {
    commandInProgress: false,
    lastCommandName: null,
    lastCommandResult: null,
  };
}

export function commandResult<T>(commandName: string, result: Result<T>): CommandResult<T> {
  return {
    ...result,
    commandName,
  };
}

export function failureResult<T>(message: string, data?: T): Result<T> {
  return {
    successful: false,
    message,
    data: data as T,
    errors: [],
  };
}
